import { createRequestDataSource } from '@ngneat/elf-requests';
import { selectCurrentPageEntities } from '@ngneat/elf-pagination';

import { executionsStore } from '@store/operations/executions/executions.store';
import { select } from '@ngneat/elf';

export const getExecutionsDataSource = createRequestDataSource({
  store: executionsStore,
  data$: () => executionsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getExecutions',
  dataKey: 'executions',
});

export const getLinkedExecutionsDataSource = createRequestDataSource({
  store: executionsStore,
  data$: () => executionsStore.pipe(select((state) => state.linkedExecution)),
  requestKey: 'getLinkedExecutionById',
  dataKey: 'linkedExecutions',
});
